exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nimg[data-v-01d1c058] {\n    width: 100%;\n    height: auto;\n    margin-bottom: 30px;\n}\n", ""]);

// exports
